/**
 * Application-wide constants
 * Centralized configuration values used throughout the application
 */

import { totalModelCount } from '@/features/home/data/homeContent'

/**
 * Base URL for the application
 * Used for generating canonical URLs, Open Graph images, and structured data
 * Falls back to production URL if APP_URL environment variable is not set
 */
export const BASE_URL =
  typeof process !== 'undefined'
    ? process.env.APP_URL || 'https://modelstack.cc'
    : 'https://modelstack.cc'

/**
 * Application name
 */
export const APP_NAME = 'ModelStack'

/**
 * Application description
 */
export const APP_DESCRIPTION = `Unrivaled access to Claude, Gemini, GPT, Kimi, QWen, and ${totalModelCount}+ leading AI models via a single, low-latency obsidian gateway.`

/**
 * Social media handles
 */
export const SOCIAL_HANDLES = {
  twitter: 'ModelStackHQ',
  github: 'modelstack',
  // linkedin: 'company/modelstack', // Uncomment when available
}

/**
 * Contact information
 */
export const CONTACT_EMAIL = 'support@modelstack.cc'
